const executedVsPlannedByProcessMANAGEMENT = (chartData) => {
  const cats =
    Array.isArray(chartData?.cats) && chartData.cats.length
      ? chartData.cats
      : [];

  const LEN = cats.length;

  const safeArr = (arr) => {
    if (!Array.isArray(arr)) return Array(LEN).fill(0);
    const out = Array(LEN).fill(0);
    for (let i = 0; i < LEN; i++) {
      const n = Number(arr[i]);
      out[i] = Number.isFinite(n) ? n : 0;
    }
    return out;
  };

  const projected = safeArr(chartData?.projected);
  const executed = safeArr(chartData?.executed);
  const deleted = safeArr(chartData?.deleted);
  const projectedNet = projected.map((p, i) => Math.max(0, (p || 0) - (deleted[i] || 0)));

  return {
    chart: { type: "column" },

    title: { text: "Cumplimiento Comparativo por Proceso" },
    subtitle: { text: "Planificadas vs Ejecutadas" },

    xAxis: {
      categories: cats,
      crosshair: true
    },

    yAxis: {
      min: 0,
      title: { text: "Cantidad de actividades" }
    },

    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        const pointIndex = this.points?.[0]?.point?.index ?? 0;
        const planificadasNetas = Number(this.points?.[0]?.y || 0);
        const ejecutadas = Number(this.points?.[1]?.y || 0);
        const eliminadas = Number(deleted[pointIndex] ?? 0);
        const cumplimiento =
          planificadasNetas > 0
            ? ((ejecutadas / planificadasNetas) * 100).toFixed(1)
            : "0.0";

        return `
          <b>${this.x}</b><br>
          Actividades planificadas: ${planificadasNetas}<br>
          Actividades ejecutadas: ${ejecutadas}<br>
          Actividades eliminadas: ${eliminadas}<br>
          Cumplimiento: <b>${cumplimiento}%</b>
        `;
      }
    },

    plotOptions: {
      column: {
        borderRadius: 4,
        pointPadding: 0.2,
        borderWidth: 0
      }
    },

    series: [
      {
        name: "Planificadas",
        data: projectedNet,
        color: "#3A74DB"
      },
      {
        name: "Ejecutadas",
        data: executed,
        color: "#1CA187"
      }
    ],

    credits: { enabled: false }
  };
};

export default executedVsPlannedByProcessMANAGEMENT;
